import { Handshake, X } from 'lucide-react';
import { useState } from 'react';
import { formatMoney } from '../utils/board.js';

function describeAssets(game, money, propertyIds) {
  const parts = [];
  if (money > 0) parts.push(`${formatMoney(money)} денег`);
  if (propertyIds.length) parts.push(propertyIds.map((id) => `«${game.board[id].name}»`).join(', '));
  return parts.join(' + ') || 'ничего';
}

export function TradeNotice({ game, viewerId, action }) {
  const trade = game.trades[0];
  const [busy, setBusy] = useState(false);
  if (!trade) return null;
  const from = game.players.find((player) => player.id === trade.fromPlayerId);
  const to = game.players.find((player) => player.id === trade.toPlayerId);
  const incoming = trade.toPlayerId === viewerId;

  const respond = async (event) => {
    setBusy(true);
    try {
      await action(event, { tradeId: trade.id });
    } catch {
      // Серверное сообщение уже показано.
    } finally {
      setBusy(false);
    }
  };

  return (
    <aside className="trade-notice" role="status">
      <Handshake size={23} />
      <div>
        <span>{incoming ? `${from.name} предлагает сделку` : `Предложение отправлено игроку ${to.name}`}</span>
        <strong>{describeAssets(game, trade.offeredMoney, trade.offeredPropertyIds)} ↔ {describeAssets(game, trade.requestedMoney, trade.requestedPropertyIds)}</strong>
      </div>
      {incoming ? (
        <div>
          <button className="button button--primary" type="button" onClick={() => respond('trade:accept')} disabled={busy}>Принять</button>
          <button className="button button--secondary" type="button" onClick={() => respond('trade:decline')} disabled={busy}>Отклонить</button>
        </div>
      ) : (
        <button className="icon-button" type="button" onClick={() => respond('trade:decline')} disabled={busy} aria-label="Отозвать предложение"><X size={18} /></button>
      )}
    </aside>
  );
}
